module.exports = __webpack_public_path__ + "static/media/myPic.25253c1b.jpg";